import React from 'react';
import './styles.css';

/**
 * 表單文本區域組件
 * 用於顯示帶有標籤的多行文本輸入框
 * 
 * @param {Object} props - 組件屬性
 * @param {string} props.id - 文本區域ID
 * @param {string} props.label - 文本區域標籤
 * @param {string} props.value - 文本區域值
 * @param {Function} props.onChange - 值變更回調函數
 * @param {string} props.placeholder - 佔位符文本
 * @param {boolean} props.required - 是否必填
 * @param {string} props.error - 錯誤信息
 * @param {number} props.rows - 行數
 * @param {string} props.className - 額外的CSS類名
 * @returns {JSX.Element} 表單文本區域組件
 */
function FormTextarea({
    id,
    label,
    value,
    onChange,
    placeholder = '',
    required = false,
    error = '',
    rows = 4,
    className = '',
    ...rest
}) {
    return (
        <div className={`form-textarea-container ${error ? 'has-error' : ''} ${className}`}>
            {label && (
                <label htmlFor={id} className="form-textarea-label">
                    {label}
                    {required && <span className="form-textarea-required">*</span>}
                </label>
            )}

            <textarea
                id={id}
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                className="form-textarea"
                required={required}
                rows={rows}
                {...rest}
            />

            {error && <p className="form-textarea-error">{error}</p>}
        </div>
    );
}

export default FormTextarea; 